module.exports = __webpack_public_path__ + "img/Star_2026.08dd215b.png";